module.exports = __webpack_public_path__ + "media/images/course-laptop-46ff7299.png";